import { useCustomerData } from '@cinch-labs/customer-data-segment'
import { sendDigitalDataEvent } from '@cinch-nx/shared-analytics'

import styles from './new-cars-promo-banner.module.css'

export function NewCarsPromoBanner() {
  const { trackEvent } = useCustomerData()
  const handleOnClick = () => {
    const data = {
      event: {
        name: 'click',
        category: 'link',
        action: 'navigate',
        label: 'new cars on cinch',
      },
    }
    trackEvent({
      type: 'track',
      eventName: 'Promotion Clicked',
      data: {
        name: 'new cars on cinch',
        position: 'top banner',
      },
    })
    sendDigitalDataEvent(data)
  }

  return (
    <div className={styles.container}>
      <span className={styles.pill}>NEW CARS</span>
      <p className={styles.text}>
        Shop{' '}
        <a href="/new-cars" onClick={handleOnClick}>
          brand new cars
        </a>{' '}
        on cinch!
      </p>
    </div>
  )
}

export default NewCarsPromoBanner
